import { createGlobalStyle } from 'styled-components';
import { archivoFont, spaceGroteskFont } from 'styles/fonts';
import { archimedesTheme } from 'styles/theme';

const $desktop = archimedesTheme.breakPoints.lg;
const $tablet = archimedesTheme.breakPoints.md;
const $mobile = archimedesTheme.breakPoints.sm;

export const GlobalStyle = createGlobalStyle`

  * {
    box-sizing: border-box;
    border: 0 solid;
    margin: 0;
    padding: 0;
  }

  html {
    font-family: ${archivoFont.style.fontFamily};
    font-weight: 300;
    line-height: 1.3;
    font-size: 10px;
  }

  body {
    font-size: 1.6rem;
    color: ${archimedesTheme.colors.functional.darkestGray};
    @media (max-width: ${$tablet}) {
      font-size: 1.4rem;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
  }

  h1 {
    font-size: 3.6rem;
    font-family: ${spaceGroteskFont.style.fontFamily};
    @media (max-width: ${$desktop}) {
      font-size: 3.2rem;
    }
  }

  h2 {
    font-size: 2.4rem;
    font-family: ${spaceGroteskFont.style.fontFamily};
    @media (max-width: ${$desktop}) {
      font-size: 1.8rem;
    }
  }
    
  h3 {
    font-size: 2.2rem;
    @media (max-width: ${$tablet}) {
      font-size: 2rem;
    }
  }

  h4 {
    font-size: 1.8rem;
    @media (max-width: ${$tablet}) {
      font-size: 1.6rem;
    }
  }

  a {
    text-decoration: none;
  }

  p {
    margin-bottom: 1.6rem;
  }

  pre {
    max-width: 100%;
    overflow-x: auto;
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  #__next {
    visibility: visible;
  }

  img, svg {
    opacity: 1;
  }

  input[type="checkbox"] {
    appearance: none;
    width: 1.8rem;
    height: 1.8rem;
    display: inline-block;
    border: 2px solid ${archimedesTheme.colors.primary.main};
    margin-top: -2px;
    &:checked {
      background-color: ${archimedesTheme.colors.primary.main};
      background: url('/checkbox.svg') center center no-repeat;
    }
  }

`;
